export const INVENTORY_STATE_ASSIGNED = 'assigned'
export const INVENTORY_STATE_DELIVERED = 'delivered'
export const INVENTORY_STATE_FOR_SALE_ONLINE = 'for_sale_online'
export const INVENTORY_STATE_UNDER_NEGOTIATION = 'under_negotiation'
export const INVENTORY_STATE_PRICE_CHANGE_REQUEST = 'price_change_request'
export const INVENTORY_STATE_RETURNED = 'returned'
export const INVENTORY_STATE_RETURNED_TRANSPORTATION_REQUEST =
  'returned_transportation_request'
export const INVENTORY_STATE_RETURNED_TRANSPORTATION_CONFIRMED =
  'returned_transportation_confirmed'
export const INVENTORY_STATE_RETURNED_CAR_LOADED = 'returned_car_loaded'
export const INVENTORY_STATE_RETURNED_CAR_ARRIVED = 'returned_car_arrived'
export const INVENTORY_STATE_PURCHASE_REQUEST = 'purchase_request'
export const INVENTORY_STATE_INVOICED = 'invoiced'
export const INVENTORY_STATE_CANCELED = 'canceled'
export const INVENTORY_STATE_PAYMENT_CONFIRMATION = 'payment_confirmation'
export const INVENTORY_STATE_SOLD = 'sold'
export const INVENTORY_STATE_DOCUMENTS_RECEIVED = 'documents_received'
export const INVENTORY_STATE_FINAL_CUSTOMER_INVOICE = 'final_customer_invoice'
export const INVENTORY_STATE_CHECK_OK = 'check_ok'

export const INVENTORY_CHANNEL_B2C = 'b2c'
export const INVENTORY_CHANNEL_B2B = 'b2b'

export const INVENTORY_REPAIR_STATE_REQUESTED = 'requested'
export const INVENTORY_REPAIR_STATE_OK = 'ok'
export const INVENTORY_REPAIR_STATE_KO = 'ko'
